import EmberRouter from '@ember/routing/router';
import config from 'ui-ember-vite/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {

  this.route('unauthorized');

  this.route('sirvo', { path: '' }, function () {
    this.route('index', { path: '' });
    this.route('empresas');
    this.route('demos');
  });
});
